<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import Carousel from '../uikit/Carousel.vue';
import type { HomePageProcess } from '~/models/homepage';
import useI18NAsync from '~/composables/i18nAsync';

const props = defineProps<{
  processes: HomePageProcess[];
  isMobileDevice: boolean;
}>();

const importedImagePath = ref([]);
const loaded = ref(false);
const i18nPF = useI18NAsync('process_families');
const i18n = useI18NAsync('components/homepage/processes_galerie');

const findImagePathInImportedImagesByName = (value: string) =>
  importedImagePath.value.find((el: string) =>
    el.includes(value.split('.')[0]),
  ) as unknown as string;

onMounted(async () => {
  const images = import.meta.glob('/assets/images/homepage/processes/*');
  const promises = props.processes.map((el) =>
    images['/assets/images/homepage/processes/' + el.image](),
  );
  importedImagePath.value = (await Promise.all(promises)).map((el: any) => el.default) as any;
  loaded.value = true;
});
</script>
<template>
  <template v-if="!isMobileDevice">
    <div class="processes-galeries grid grid-6-columns">
      <div v-for="process in props.processes" :key="process.id" class="relative">
        <img :src="findImagePathInImportedImagesByName(process.image)" />
        <div class="process-galerie-title pa-5px text-center">
          <i18nPF :ikey="process.name" />
        </div>
      </div>
      <div class="relative">
        <img
          src="/assets/images/homepage/processes/processes_more_RO_bf.webp"
          alt="more processes to come"
        />
        <div class="process-galerie-title pa-5px text-center">
          <i18n ikey="andMore" />
        </div>
      </div>
    </div>
  </template>
  <template v-else>
    <div class="processes-galeries process-carousel" v-if="loaded">
      <Carousel
        :images="props.processes.map((el) => findImagePathInImportedImagesByName(el.image))"
      />
    </div>
  </template>
</template>
<style lang="scss" scoped>
@use '/assets/scss/variables' as variables;

.grid img {
  height: auto;
  width: 100%;
  transition: transform 500ms ease;
}

.grid img:hover {
  transform: scale(1.5);
}
.process-carousel {
  overflow: hidden;
}
.process-galerie-title {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: rgba(0, 60, 90, 0.8);
  color: white;
  font-size: 20px;
  line-height: 60px;

  @include variables.for-mid {
    font-size: 18px;
    line-height: 30px;
  }
}

.processes-galeries .relative {
  overflow: hidden;
}
</style>
